import { render, staticRenderFns } from "./MyPoster.vue?vue&type=template&id=0f843cc5&scoped=true&"
import script from "./MyPoster.vue?vue&type=script&lang=js&"
export * from "./MyPoster.vue?vue&type=script&lang=js&"
import style0 from "./MyPoster.vue?vue&type=style&index=0&id=0f843cc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f843cc5",
  null
  
)

export default component.exports